


$(".parallaxSlider").each(function (index, sliderWrap) {
  var $slider = $(sliderWrap).find(".slider");
  var $prev = $(sliderWrap).find(".slick-prev");
  var $next = $(sliderWrap).find(".slick-next");


  $slider.slick({
    dots: false,    
    infinite: true,
    speed: 1800,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    prevArrow: $prev,
    nextArrow: $next,    
  });
});

$(".responsive-slider").each(function () {
  const numSlides = $(this).find(".responsive-slider__slide").length;

  const slickOptions = {
    dots: false,
    infinite: true,
    speed: 300,
    rows: numSlides > 5 ? 2 : 1,
    slidesToShow: numSlides > 2 ? 5 : 2,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1550,
        settings: {
          rows: numSlides > 4 ? 2 : 1,
          slidesToShow: numSlides > 2 ? 6 : 2,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1390,
        settings: {
          rows: numSlides > 3 ? 2 : 1,
          slidesToShow: numSlides > 2 ? 4 : 2,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          rows: numSlides > 2 ? 2 : 1,
          slidesToShow: numSlides > 2 ? 2 : 1,
          slidesToScroll: numSlides > 2 ? 2 : 1,
        },
      },
    ],
  };

  $(this).slick(slickOptions);

  //check if there are more than 3 elements
  if (numSlides < 3) {
    //if so get the last 2 elements and add the class
    $(this).addClass("two-item-slider");
  }

  //check if there are more than 5 elements
  if (numSlides < 6) {
    //if so get the last 2 elements and add the class
    $(this).addClass("single-row-slider");
  }

  // $(this).addClass("single-row-slider");
});

$(".cutoff-wrapper").each(function (index, sliderWrap) {
  var $slider = $(sliderWrap).find(".cutoff-slider");
  var $prev = $(sliderWrap).find(".slick-prev");
  var $next = $(sliderWrap).find(".slick-next");
  $slider.slick({
    prevArrow: $prev,
    nextArrow: $next,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    autoplay: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(".event-slider-wrapper").each(function (index, eventWrap) {
  var $eventSlider = $(eventWrap).find(".event-slider");
  var $indicatorSlider = $(eventWrap).find(".event-indicator-slider");
  const numSlides = $eventSlider.find(".event-slider__slide:not(.slick-cloned)").length;
  var $prev = $(eventWrap).find(".slick-prev");
  var $next = $(eventWrap).find(".slick-next");
  
  $eventSlider.slick({
    infinite: true,
    prevArrow: $prev,
    nextArrow: $next,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1390,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $indicatorSlider.slick({
    arrows: false,
    infinite: true,
    slidesToShow: numSlides,
    slidesToScroll: 1,
    asNavFor: $eventSlider
  });

  // Dynamically add .owa-figure as the first element of $indicatorSlider
  $indicatorSlider.prepend('<div class="owa-figure"></div>');
  
  // Add class to the first slide of the second slider initially based on the first slider's current slide
  var firstSliderCurrentIndex = $eventSlider.find('.slick-current').index();
  $indicatorSlider.find('.slick-slide').eq(firstSliderCurrentIndex).addClass('current-indicator');

  // Add class to the current slide of the second slider
  $eventSlider.on('afterChange', function(event, slick, currentSlide) {
    $indicatorSlider.find('.slick-slide').removeClass('current-indicator');
    $indicatorSlider.find('.slick-slide').eq(currentSlide).addClass('current-indicator');

    // Update left value of .owa-figure
    updateOwaFigurePosition();
  });

  function updateOwaFigurePosition() {
    var $currentIndicator = $indicatorSlider.find('.current-indicator');
    var indicatorSliderWidth = $indicatorSlider.outerWidth(); // Width of the event-indicator-slider
    var slideWidth = (indicatorSliderWidth - 50) / (numSlides - 1); // Width of each slide

    // Calculate the left value based on the position of the current indicator
    var leftValue = $currentIndicator.index() * slideWidth;

    // Set the left value for .owa-figure
    $(".owa-figure").css({
      left: leftValue
    });
  }
  
});






